export const SUPPORT_TOOLBAR = [
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'subscript',
  'superscript',
  '|',
  'heading',
  '|',
  'fontSize',
  '|',
  'uploadImage',
  'insertTable',
  'horizontalLine',
  'specialCharacters',
  '|',
  'bulletedList',
  'numberedList',
  '|',
  'outdent',
  'alignment',
  'indent',
  '|',
  'link',
  'undo',
  'redo',
  '|',
  'findAndReplace',
];
